import { render, staticRenderFns } from "./DashboardStatsWidget.vue?vue&type=template&id=a270103e&"
import script from "./DashboardStatsWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardStatsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports